import {
  PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS,
  PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS,
} from 'containers/PhotoSessions/types';

import {
  PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS,
  PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS,
  PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS,
  PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS,
  PHOTO_SESSION_START_CLICKED_ANALYTICS,
  PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS,
} from 'containers/PhotoSessionDetail/types';

import { logWithDefaultProperties } from '../defaultLogger';
import { PAGE_NAMES } from '../constants';

export const handlePhotoSessionsActions = (amplitudeInstance, action) => {
  switch (action.type) {
    case PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSIONS_LIST,
        eventName: 'photo_session_list_viewed',
      });
      break;

    case PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSIONS_LIST,
        eventName: 'photo_session_list_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'photo_session_detail_viewed',
        extraProperties: action.extraProperties,
        userProperties: action.userProperties,
      });
      break;

    case PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'photo_session_detail_confirmation_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'photo_session_detail_call_owner_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'photo_session_detail_directions_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_START_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'photo_session_start_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PHOTO_SESSION_DETAIL,
        eventName: 'entry_model_alert_link_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    default:
      break;
  }
};

export default handlePhotoSessionsActions;
